// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const GeneratorEnvironment = {
    local: () => {
        return {
            type: "local",
            _visit: function (visitor) {
                return FernIr.generatorExec.GeneratorEnvironment._visit(this, visitor);
            },
        };
    },
    remote: (value) => {
        return Object.assign(Object.assign({}, value), { type: "remote", _visit: function (visitor) {
                return FernIr.generatorExec.GeneratorEnvironment._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "local":
                return visitor.local();
            case "remote":
                return visitor.remote(value);
            default:
                return visitor._other(value);
        }
    },
};
